import React from 'react';

import {
  Visibility as IconVisibility,
  VisibilityOff as IconVisibilityOff,
} from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';

import { TextField, TextFieldProps } from '../TextField';

type PasswordFieldProps = TextFieldProps;

export const PasswordField: React.FC<PasswordFieldProps> = props => {
  const { slotProps, ...restProps } = props;

  const [showPassword, setShowPassword] = React.useState(false);

  const togglePassword = React.useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setShowPassword(showPassword => !showPassword);
  }, []);

  return (
    <TextField
      slotProps={{
        ...slotProps,
        input: {
          type: !showPassword ? 'password' : 'text',
          endAdornment: (
            <InputAdornment position="end">
              <IconButton aria-label="Toggle password visibility" onClick={togglePassword}>
                {showPassword ? <IconVisibilityOff /> : <IconVisibility />}
              </IconButton>
            </InputAdornment>
          ),
          ...slotProps?.input,
        },
      }}
      {...restProps}
    />
  );
};
